import * as React from 'react';
import { Icon } from '../Icon';
import './customButton.scss';

export interface ICustomButtonProps {
    className?: string;
    icon: string;
    type?: "button" | "reset" | "submit";
    onClick?: Function;
}

export class CustomButton extends React.PureComponent<ICustomButtonProps, {}> {
    constructor(props: ICustomButtonProps) {
        super(props);
    }

    public render() {
        return <button onClick={() => this.props.onClick()} 
        type={this.props.type} className={`${this.props.className} button`} >
            <Icon icon={this.props.icon} />
            {this.props.children}
        </button>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/CustomButton/index.tsx